import { render, staticRenderFns } from "./ProductMarketWidget.vue?vue&type=template&id=442543ff&scoped=true"
import script from "./ProductMarketWidget.vue?vue&type=script&lang=js"
export * from "./ProductMarketWidget.vue?vue&type=script&lang=js"
import style0 from "./ProductMarketWidget.vue?vue&type=style&index=0&id=442543ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442543ff",
  null
  
)

export default component.exports